import _ from 'lodash';
import { createReducer, on } from '@ngrx/store';
import * as GuestInformationListActions from './guest-information-list.actions';

export const guestInformationListFeatureKey = 'guestInformationList';

export interface State {
}


export const initialState: State = {
};

export const reducer = createReducer(
  initialState,
);

